import React, { useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from "@material-ui/core/ListItemText";
import { Groupbox, TextField } from 'components/Form';
import { FiltersContext } from 'contexts';

const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%'
  },
  menuItem: {
    minHeight: '36px'
  },
  refineLabel: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '18px'
  },
  refinersGroupbox: {
    marginTop: '16px'
  },
  listItemText: { fontSize: '14px', lineHeight: '20px' },
  listItem: { paddingTop: '4px', paddingBottom: '4px' },
}));

export default (props) => {
  const classes = useStyles();
  const {
    state: filtersState,
    actions: filtersActions
  } = useContext(FiltersContext);

  useEffect(() => {
    const { productsFilters, roles } = props;
    filtersActions.getBusinessUnits(productsFilters?.filters, roles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productsFilters?.filters, props.roles]);

  useEffect(() => {
    const { productsFilters, values } = props;
    filtersActions.getCategories(values.businessUnit, productsFilters?.schemes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values.businessUnit, props.productsFilters?.schemes]);

  const changeAndSubmit = (event) => {
    if (event?.target?.name === 'businessUnit') {
      props.handleChange({ target: { name: 'category', value: '' } });
      props.handleChange({ target: { name: 'specifier', value: '' } });
    } else if (event?.target?.name === 'category') {
      props.handleChange({ target: { name: 'specifier', value: '' } });
    }

    props.handleChange(event);
    props.submitForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const onSpecifierClick = (name) => {
    props.handleChange({
      target: {
        name: 'specifier',
        value: props.values.specifier !== name
          ? name
          : ''
      }
    });
    props.submitForm();
  };

  const showRefiners = props.values.businessUnit && props.values.category;

  const renderRefiners = () => {
    if (!props.values.businessUnit || !props.values.category)
      return null;

    const categoryScheme = props.productsFilters
      ?.schemes[props.values.businessUnit]
      ?.find(e => e.route === props.values.category);

    return (
      <Groupbox className={classes.refinersGroupbox}>
        <span className={classes.refineLabel}>
          {`Refine ${categoryScheme?.label}`}
        </span>
        <List
          component="nav"
          aria-label="secondary mailbox folder"
        >
          {
            categoryScheme?.specifiers
              .map(q => (
                <ListItem
                  button
                  classes={{ root: classes.listItem }}
                  selected={props.values.specifier === q.name}
                  key={q.name}
                  onClick={() => onSpecifierClick(q.name)}
                >
                  <ListItemText
                    classes={{ primary: classes.listItemText }}
                    primary={q.label}
                  />
                </ListItem>
              ))
          }
        </List>
      </Groupbox>
    );
  };

  return (
    <>
      <Groupbox>
        <TextField
          variant="outlined"
          margin="normal"
          select
          id="businessUnit"
          label="Business Unit"
          name="businessUnit"
          size="small"
          onChange={changeAndSubmit}
          className={classes.input}
          value={props.values.businessUnit}
        >
          {filtersState.businessUnits.map((option) => (
            <MenuItem
              className={classes.menuItem}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          variant="outlined"
          margin="normal"
          select
          id="category"
          label="Category"
          disabled={props.values.businessUnit === ''}
          name="category"
          size="small"
          onChange={changeAndSubmit}
          className={classes.input}
          value={props.values.category}
        >
          {filtersState.categories.map((option) => (
            <MenuItem
              className={classes.menuItem}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Groupbox>
      {
        showRefiners && renderRefiners()
      }
    </>
  );
};